import type React from "react";
import type { IRecentItem } from "../types";
import { ItemIconChain } from "@similarweb/ui-components";
import {
    StyledIconWrapper,
    StretchedIconContainer,
} from "app/pages/digital-suite/home-page/components/RecentsWidget/Icons/styledComponents";

interface UnaryIconProps {
    item: IRecentItem;
}

export const UnaryIcon: React.FC<UnaryIconProps> = (props) => {
    return (
        <StyledIconWrapper>
            <StretchedIconContainer>
                <ItemIconChain
                    icons={[props.item.icon]}
                    size={32}
                    maxIconChain={1}
                />
            </StretchedIconContainer>
        </StyledIconWrapper>
    );
};
